import * as auth from 'app/modules/auth/core/AuthHelpers'

const useUser = () => {
  var user = auth.getUser()
  return {user}
}

export {useUser}
